module.exports = __webpack_public_path__ + "img/cegep_beauce_appalache.50d33f53.webp";